import * as Turbo from '@hotwired/turbo';
import { registerSvelteControllerComponents } from '@symfony/ux-svelte';

// Load vendor styles before Tailwind utilities so utility classes can override component defaults.
import './css/global.css';
// any CSS you import will output into a single css file (app.scss in this case)
import './css/backoffice/app.scss';
// needed for vtmn-play integration
import './css/backpack/autocomplete.scss';
import './css/backpack/inbox.css';
import './css/components/input-number.scss';

// start the Stimulus application
import { startStimulusApp } from '@symfony/reprise/stimulus';

// import custom js
import './js/partner/partner.js';

Turbo.session.drive = false;

// Registers Stimulus controllers from controllers.json and in the controllers/ directory
startStimulusApp();

const svelteBackofficeControllers = import.meta.glob(
    './svelte/backoffice/controllers/*.svelte',
    { eager: true },
);

// Create a custom context function that behaves like import.meta.webpackContext for registerSvelteControllerComponents to work
const customContext = function (key) {
    return customContext._components[key];
};

customContext._components = Object.fromEntries(
    Object.entries(svelteBackofficeControllers).map(([path, module]) => [
        path.replace('./svelte/backoffice/controllers', '.'),
        module,
    ]),
);

customContext.keys = function () {
    return Object.keys(this._components);
};

registerSvelteControllerComponents(customContext);
